<template>
  <a href="/favorites" class="favorite-snackbar" aria-label= "Favorites">
    <Snackbar :show="show" :position="position" class="snackbar">
      <div class="snackbar-content flex-grid">
        <div class="flex-col-1-xs">
          <span class="af af-heart-full"></span>
        </div>
        <div class="flex-col-10-xs message">
          <span>Added to your Favorites</span>
        </div>
        <div class="flex-col-1-xs arrow-right">
          <span class="af af-chevron-right"></span>
        </div>
      </div>
    </Snackbar>
  </a>
</template>

<script>
import { Snackbar, MediaUtils } from '@/pixel/index';

export default {
  name: 'FavoriteSnackbar',
  components: {
    Snackbar,
  },
  props: {
    show: {
      type: Boolean,
    },
  },
  computed: {
    position() {
      if (MediaUtils.isMobileAndSmaller) {
        return 'top';
      }
      return 'left';
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.favorite-snackbar {
  background: var(--grey-ultra-light);

  .snackbar {
    @media (min-width: $mobile-breakpoint) {
      width: 375px !important;
      box-sizing: border-box;
    }

    .snackbar-content {
      width: 100%;
      align-items: center;

      .af-heart-full {
        color: var(--coral);
      }

      .arrow-right {
        text-align: right;
      }
    }
  }
}
</style>
